"use client"
import { useEffect, useState } from "react"

export const getIsLocalhost = () => {
  return typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
}

export const DoNotShareModal = ({ onDismiss }: { onDismiss: () => void }) => {
  const [isLocalhost, setIsLocalhost] = useState<boolean | null>(null)
  useEffect(() => {
    setIsLocalhost(getIsLocalhost())
  }, [])
  if (isLocalhost) return null
  
  return (
    <div className="fixed inset-0 bg-black flex items-center justify-center z-[1200]">
      <div className="bg-black text-white p-32 flex flex-col items-center gap-24">
        <div className="text-4xl font-bold text-center uppercase">Draft<br/><br/>Do not share</div>
        <button
          onClick={onDismiss}
          className="border-white border-2 rounded-md text-white px-4 py-2 text-xl font-bold hover:bg-gray-500 cursor-pointer"
        >
          I agree not to share
        </button>
      </div>
    </div>
  )
}
